
import ConfigPage from '../../../../page/helpers/ConfigPage';
import ConfigScene from '../../../helpers/ConfigScene';

class ActiveItem extends PIXI.Container {
  constructor(itemData) {
    super();

    // conts
    this.SLOW_FADES = [11];
    this.FADE_SLOW = 0.5;
    this.FADE_FAST = 0.1;

    // vars
    this.fadeTime = 0.1;
    this.itemId = 0;
    this.itemName = '';
    this.itemType = 1; // 1/2 - number of frames
    this.itemData = itemData;
    this.hovered = false;
    this.touchUps = 0; // for touch select (on second tap)
    this.isMikulas = this.itemData.id.indexOf('mikulas') !== -1;

    // parts
    this.zeroStateBm = null;
    this.mainStateBm = null;

    // hit
    this.hitFc = null; // hit function reference
    this.globalPos = new PIXI.Point(0, 0);
    this.hitOffset = new PIXI.Point(
      this.itemData.hit.hX,
      this.itemData.hit.hY,
    );

    // init
    this.init();
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  init() {
    // props + vars
    const idArray = this.itemData.id.split('_');
    this.itemId = Number(idArray[0]);
    this.itemName = `${idArray[1]}${this.isMikulas ? '-mikulas' : ''}`;
    this.itemType = Number(idArray[2]);
    this.x = this.itemData.iX;
    this.y = this.itemData.iY;

    // set fade time
    if (this.SLOW_FADES.indexOf(this.itemId) === -1) {
      this.fadeTime = this.FADE_FAST;
    } else {
      this.fadeTime = this.FADE_SLOW;
    }

    // save hit function ref
    switch (this.itemData.hit.hT) {
      case 1:
        this.hitFc = aScene.collisionHelper.hitCircle;
        break;
      case 2:
        this.hitFc = aScene.collisionHelper.hitRect;
        break;
      default:
    }

    // set parts
    this.setStateBm();

    // save ref
    aScene.itemsHelper.items.push(this);

    // debug
    if (ConfigPage.DEBUG) {
      this.drawHitArea();
    }

    // lsns
    aScene.signals.itemCall.add(this.itemCallFc, this);
  }

  // --------------------------------------------------------------
  // Lsn
  // --------------------------------------------------------------

  itemCallFc(sgType, optParams) {
    // try un/hover
    if (sgType === ConfigScene.E_ITEM_HOVER) {
      if (optParams === this.itemId) {
        this.setHoverState(true);
      } else {
        this.setHoverState(false);
      }
    }
  }

  // --------------------------------------------------------------
  // Hover
  // --------------------------------------------------------------

  setHoverState(doHover) {
    if (doHover) {
      if (!this.hovered) {
        this.touchUps = 0;
        this.hovered = true;
        this.mainStateBm.visible = true;

        if (this.itemType === 2) {
          this.zeroStateBm.visible = false;
        } else {
          // effect
          TweenMax.killTweensOf(this.mainStateBm);
          TweenMax.to(this.mainStateBm, this.fadeTime, { alpha: 1.0 });
        }
        // play sfx
        aScene.sndManager.playItemSfx(this.itemName);
      }
    } else if (this.hovered) {
      this.hovered = false;

      if (this.itemType === 2) {
        this.zeroStateBm.visible = true;
        this.mainStateBm.visible = false;
      } else {
        // effect
        TweenMax.killTweensOf(this.mainStateBm);
        TweenMax.to(this.mainStateBm, this.fadeTime, {
          alpha: 0.0,
          onComplete: this.unHoverEnd,
          onCompleteScope: this,
        });
      }
      // try stop sfx
      aScene.sndManager.stopItemSfx(this.itemName);
    }
  }

  unHoverEnd() {
    this.mainStateBm.visible = false;
  }

  // --------------------------------------------------------------
  // State bitmap
  // --------------------------------------------------------------

  setStateBm() {
    // main
    this.mainStateBm = new PIXI.Sprite.fromFrame(`${this.itemName}-1.png`);
    this.addChild(this.mainStateBm);
    // init state
    this.mainStateBm.visible = false;
    // try zero
    if (this.itemType === 2) {
      this.zeroStateBm = new PIXI.Sprite.fromFrame(`${this.itemName}-0.png`);
      this.addChild(this.zeroStateBm);
    } else {
      this.mainStateBm.alpha = 0;
    }
  }

  // --------------------------------------------------------------
  // HitArea
  // --------------------------------------------------------------

  drawHitArea() {
    const debugGr = new PIXI.Graphics();
    debugGr.beginFill('0xFF0000', 0.4);
    if (this.itemData.hit) {
      switch (this.itemData.hit.hT) {
        case 1:
          debugGr.drawCircle(
            this.itemData.hit.hX,
            this.itemData.hit.hY,
            this.itemData.hit.hR,
          );
          break;
        case 2:
          debugGr.drawRect(
            this.itemData.hit.hX,
            this.itemData.hit.hY,
            this.itemData.hit.hW,
            this.itemData.hit.hH,
          );
          break;
        default:
      }
    }
    debugGr.endFill();
    this.addChild(debugGr);
  }

  // --------------------------------------------------------------
  // Hit
  // --------------------------------------------------------------

  tryHit() {
    // global hit position
    aScene.pixi.stage.toLocal(this.hitOffset, this, this.globalPos);
    // try hit
    return this.hitFc.call(this, this.globalPos, this.itemData.hit);
  }

  // --------------------------------------------------------------
  // Bullet position
  // --------------------------------------------------------------

  getBulletPos() {
    return {
      x: (this.itemData.iX + this.itemData.hint.hX) * aPage.resizer.scaleMain,
      y: (this.itemData.iY + this.itemData.hint.hY) * aPage.resizer.scaleMain,
    };
  }
}

export default ActiveItem;



// WEBPACK FOOTER //
// ./src/js/scene/parts/town/parts/ActiveItem.js